export const environment = {
  production: true,
  
  apiUrl: "https://umyogossip.site/api_umyocards/public/api/",
  reverbKey: 'umyo_reverb_key_123',
  reverbHost: 'reverb.umyogossip.site',
  digitalCardPackageId: 97
};